import { Badge } from "@/components/ui/badge";
import {
  type ESignatureStatus,
  STATUS_TONE,
} from "@/features/esignatures/types";
import { cn } from "@/lib/utils";

interface Props {
  status: ESignatureStatus;
  label: string;
  /** Extra context shown as a title tooltip (e.g. bounce reason, progress). */
  title?: string;
}

/** Status pill for an e-signature request/recipient. Colours come from the
 * semantic tokens in `types.ts` (no hardcoded hex). */
export function ESignatureStatusBadge({ status, label, title }: Props) {
  return (
    <Badge
      variant="outline"
      title={title}
      className={cn(
        "border-transparent text-[11px] font-semibold",
        STATUS_TONE[status],
      )}
    >
      {label}
    </Badge>
  );
}
